import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getQueryParamByName } from '@yme/utils/common';
import { PARAMS_KEYS } from './constants';
import { convertDealerIdParamToString, convertIframeParamToBoolean } from './helpers';
export const useQueryParams = ({ isShowDriverLicenseFilter = false, }) => {
    const history = useHistory();
    const location = useLocation();
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const getQueryParams = useCallback(() => {
        return {
            page: Number(getQueryParamByName(history.location.search, PARAMS_KEYS.page)),
            perPage: Number(getQueryParamByName(history.location.search, PARAMS_KEYS.perPage)),
            driverLicense: (getQueryParamByName(history.location.search, PARAMS_KEYS.driverLicense) ||
                undefined),
            isIframe: convertIframeParamToBoolean(getQueryParamByName(history.location.search, PARAMS_KEYS.isIframe)),
            dealerId: convertDealerIdParamToString(getQueryParamByName(history.location.search, PARAMS_KEYS.dealerId)) ||
                convertDealerIdParamToString(getQueryParamByName(history.location.search, PARAMS_KEYS.dealerIds)),
        };
    }, [history.location.search]);
    const updateQueryParams = useCallback((updatedParams) => {
        if (typeof updatedParams.page === 'number') {
            searchParams.set(PARAMS_KEYS.page, String(updatedParams.page));
        }
        if (typeof updatedParams.perPage === 'number') {
            searchParams.set(PARAMS_KEYS.perPage, String(updatedParams.perPage));
        }
        if (typeof updatedParams.driverLicense === 'string' && isShowDriverLicenseFilter) {
            searchParams.set(PARAMS_KEYS.driverLicense, updatedParams.driverLicense);
        }
        history.push({
            pathname: location.pathname,
            search: searchParams.toString(),
        });
    }, [history, isShowDriverLicenseFilter, location.pathname, searchParams]);
    return {
        getQueryParams,
        updateQueryParams,
    };
};
